import { API_ACTIONS, API_ACTION_TYPES } from "@Utils";
import { EXLY_BACKEND_API_HOST } from "repoV2/constants/apis";
import { prependBackendAPIHost } from "repoV2/utils/common/api/api";

export const BRANDED_COMMUNITY_API_URLS = {
    GET_ONBOARDING_FLAG: `${EXLY_BACKEND_API_HOST}/community/check/guided/flow`,
    SET_ONBOARDING_FLAG: `${EXLY_BACKEND_API_HOST}/community/mark/guided/flow `,

    GET_HOST_PROFILE: (hostName: string) =>
        `${EXLY_BACKEND_API_HOST}${API_ACTIONS[API_ACTION_TYPES.FETCH_HOST].url(
            { hostName, minify: true }
        )}`,

    GET_COMMUNITY_OFFERINGS: `${EXLY_BACKEND_API_HOST}/community/get/community/offerings`,

    // apis to track last seen post in channel and feed
    FEED_VIEW_ACTION: `${EXLY_BACKEND_API_HOST}/community/update/section/opentime`,
    GET_LAST_FEED_VIEW_TIME: `${EXLY_BACKEND_API_HOST}/community/get/post/timedata`,
    CHANNEL_VIEW_ACTION: `${EXLY_BACKEND_API_HOST}/community/channel/view/action`,

    GET_GROUPS: `${EXLY_BACKEND_API_HOST}/community/list/groups/community`,
    GET_COMMUNITY_MEMBERS: `${EXLY_BACKEND_API_HOST}/community/member/list`,
    CREATE_CUSTOMER_PROFILE: `${EXLY_BACKEND_API_HOST}/community/create/customer/profile`,
    GET_COMMUNITY_PROFILE: `${EXLY_BACKEND_API_HOST}/community/get/community/profile`,
    UPDATE_CUSTOMER_PROFILE: `${EXLY_BACKEND_API_HOST}/community/update/customer/profile`,

    GET_DIRECT_CHAT_DETAILS: `${EXLY_BACKEND_API_HOST}/community/get/directchat/channel`,
    UPDATE_DIRECT_CHAT_DETAILS: `${EXLY_BACKEND_API_HOST}/community/update/directchat/channel`,

    CREATE_COMMUNITY_POST: `${EXLY_BACKEND_API_HOST}/community/create/community/post`,
    GET_COMMUNITY_POSTS_LIST: `${EXLY_BACKEND_API_HOST}/community/get/normal/posts/v2`,
    GET_COMMUNITY_PINNED_POSTS_LIST: `${EXLY_BACKEND_API_HOST}/community/get/pinned/posts/v2`,
    PIN_COMMUNITY_POST: `${EXLY_BACKEND_API_HOST}/community/pin/community/post`,
    UPDATE_COMMUNITY_POST: `${EXLY_BACKEND_API_HOST}/community/edit/community/post`,
    DELETE_COMMUNITY_POST: `${EXLY_BACKEND_API_HOST}/community/delete/community/post`,
    LIKE_COMMUNITY_POST: `${EXLY_BACKEND_API_HOST}/community/like/community/post`,
    GET_COMMUNITY_POST_LIKED_BY_USERS_LIST: `${EXLY_BACKEND_API_HOST}/community/post/reaction/list`,
    CREATE_COMMUNITY_POST_COMMENT: `${EXLY_BACKEND_API_HOST}/community/post/comment/create`,
    GET_COMMUNITY_POST_COMMENTS: `${EXLY_BACKEND_API_HOST}/community/post/comment/list`,
    LIKE_COMMUNITY_POST_COMMENT: `${EXLY_BACKEND_API_HOST}/community/post/comment/reaction/save`,
    GET_COMMUNITY_POST_COMMENT_LIKED_BY_USERS_LIST: `${EXLY_BACKEND_API_HOST}/community/post/comment/reaction/users/list`,
    EDIT_COMMUNITY_POST_COMMENT: `${EXLY_BACKEND_API_HOST}/community/post/comment/edit`,
    DELETE_COMMUNITY_POST_COMMENT: `${EXLY_BACKEND_API_HOST}/community/post/comment/delete`,
    GET_COMMUNITY_POST_COMMENT_REPLIES: `${EXLY_BACKEND_API_HOST}/community/post/comment/replies/list`,
    CAST_VOTE: `${EXLY_BACKEND_API_HOST}/community/poll/vote`,
    GET_POLL_VOTES: `${EXLY_BACKEND_API_HOST}/community/poll/option/voters/paginated/list`,
    GET_POST_SHARE_LINK: prependBackendAPIHost(
        "community/customer/post/link/get"
    ),
    GET_PUBLIC_POST: prependBackendAPIHost("community/customer/open/post/get"),

    CREATE_COMMUNITY_CHANNEL_POST: `${EXLY_BACKEND_API_HOST}/community/create/exly/feed/post`,
    GET_COMMUNITY_CHANNEL_POSTS_LIST: `${EXLY_BACKEND_API_HOST}/community/feed/channel/posts/get/v2`,
    UPDATE_COMMUNITY_CHANNEL_POST: `${EXLY_BACKEND_API_HOST}/community/edit/feed/post`,
    DELETE_COMMUNITY_CHANNEL_POST: `${EXLY_BACKEND_API_HOST}/community/delete/feed/post`,
    LIKE_COMMUNITY_CHANNEL_POST: `${EXLY_BACKEND_API_HOST}/community/reaction/channel/post`,
    GET_COMMUNITY_CHANNEL_POST_LIKED_BY_USERS_LIST: `${EXLY_BACKEND_API_HOST}/community/list/users/feed/channel/post/reaction`,
    PIN_COMMUNITY_CHANNEL_POST: `${EXLY_BACKEND_API_HOST}/community/pin/feed/post`,
    CREATE_COMMUNITY_CHANNEL_POST_COMMENT: `${EXLY_BACKEND_API_HOST}/community/create/comment/channel/post`,
    GET_COMMUNITY_CHANNEL_POST_COMMENTS: `${EXLY_BACKEND_API_HOST}/community/list/comment/channel/post`,
    DELETE_COMMUNITY_CHANNEL_POST_COMMENT: `${EXLY_BACKEND_API_HOST}/community/delete/comment/channel/post`,
    EDIT_COMMUNITY_CHANNEL_POST_COMMENT: `${EXLY_BACKEND_API_HOST}/community/edit/comment/channel/post`,
    LIKE_COMMUNITY_CHANNEL_POST_COMMENT: `${EXLY_BACKEND_API_HOST}/community/save/reaction/comment/channel/post`,
    GET_COMMUNITY_CHANNEL_POST_COMMENT_LIKED_BY_USERS_LIST: `${EXLY_BACKEND_API_HOST}/community/list/users/reaction/feed/channel/post/comment`,
    GET_COMMUNITY_CHANNEL_POST_COMMENT_REPLIES: `${EXLY_BACKEND_API_HOST}/community/list/replies/comment/channel/post`,

    GET_CUSTOM_LINKS_LIST: `${EXLY_BACKEND_API_HOST}/community/custom/link/list`,
    GET_PREVIEW_LINKS_LIST: `${EXLY_BACKEND_API_HOST}/community/post/link/preview/list`,
};
